// extracted by mini-css-extract-plugin
export default {"tab":"his_tab__L0+8v","top":"his_top__016AY","center":"his_center__-Otiu","item":"his_item__IzzFr"};